import { defineStore } from 'pinia';
import api from "@/api";


export const useGajiSettingStore = defineStore('gajiSetting', {
  actions: {
    async getTunAir() {
      try {
          const response = await api.get('/tunAir'); // clean and reusable 😘
        return response.data; // no state storage — just fresh & flirty
      } catch (error) {
        console.error('Uh-oh... failed to fetch TunAir 💔', error);
        throw error;
      }
    },

    // add more fresh-fetching methods here as your heart desires
    async getTunPangan() {
      try {
          const response = await api.get('/tunPangan'); // clean and reusable 😘
        return response.data; // no state storage — just fresh & flirty
      } catch (error) {
        console.error('Uh-oh... failed to fetch TunPangan 💔', error);
        throw error;
      }
    },

     async getTunPanganDetail() {
      try {
          const response = await api.get('/tunPanganDetail'); // clean and reusable 😘
        return response.data; // no state storage — just fresh & flirty
      } catch (error) {
        console.error('Uh-oh... failed to fetch tunPanganDetail 💔', error);
        throw error;
      }
    },

     async getTunJabatan() {
      try {
          const response = await api.get('/tunJabatan'); // clean and reusable 😘
        return response.data; // no state storage — just fresh & flirty
      } catch (error) {
        console.error('Uh-oh... failed to fetch tunJabatan 💔', error);
        throw error;
      }
    },
     async getTunJabatanDetail() {
      try {
          const response = await api.get('/tunJabatanDetail'); // clean and reusable 😘
        return response.data; // no state storage — just fresh & flirty
      } catch (error) {
        console.error('Uh-oh... failed to fetch tunJabatanDetail 💔', error);
        throw error;
      }
    },
     async getGajiSkema() {
      try {
          const response = await api.get('/gajiSkema'); // clean and reusable 😘
        return response.data; // no state storage — just fresh & flirty
      } catch (error) {
        console.error('Uh-oh... failed to fetch gajiSkema 💔', error);
        throw error;
      }
    },

     async getGajiSkemaDirut() {
      try {
        let pegawaiStatus = 1; //direksi
        let jabatanId = 1;//dirut

        const response = await api.get(`/gajiSkema/${pegawaiStatus}/${jabatanId}`); // clean and reusable 😘
        return response.data; // no state storage — just fresh & flirty
      } catch (error) {
        console.error('Uh-oh... failed to fetch getGajiSkemaDirut 💔', error);
        throw error;
      }
    },

     async getGajiSkemaDirum() {
      try {
        let pegawaiStatus = 1; //direksi
        let jabatanId = 2;//dirum

        const response = await api.get(`/gajiSkema/${pegawaiStatus}/${jabatanId}`); // clean and reusable 😘
        return response.data; // no state storage — just fresh & flirty
      } catch (error) {
        console.error('Uh-oh... failed to fetch getGajiSkemaDirum 💔', error);
        throw error;
      }
    },



    async getGajiSkemaDirtek() {
      try {
        let pegawaiStatus = 1; //direksi
        let jabatanId = 3;//dirtek

        const response = await api.get(`/gajiSkema/${pegawaiStatus}/${jabatanId}`); // clean and reusable 😘
        return response.data; // no state storage — just fresh & flirty
      } catch (error) {
        console.error('Uh-oh... failed to fetch getGajiSkemaDirtek 💔', error);
        throw error;
      }
    },

    async getGajiSkemaDewas() {
      try {
        let pegawaiStatus = 6; //dewas
        // let jabatanId = 3;//dirtek

        const response = await api.get(`/gajiSkema/${pegawaiStatus}`); // clean and reusable 😘
        return response.data; // no state storage — just fresh & flirty
      } catch (error) {
        console.error('Uh-oh... failed to fetch getGajiSkemaDewas 💔', error);
        throw error;
      }
    },

    async getGajiSkemaKomponen() {
      try {
          const response = await api.get(`/gajiSkemaKomponen`); 
        return response.data; // no state storage — just fresh & flirty
      } catch (error) {
        console.error('Uh-oh... failed to fetch getGajiSkemaKomponen 💔', error);
        throw error;
      }
    },


     async getGajiSkemaTetap() {
      try {
        let pegawaiStatus = 2; //tetap
        // let jabatanId = 3;//dirtek

        const response = await api.get(`/gajiSkema/${pegawaiStatus}`); // clean and reusable 😘
        return response.data; // no state storage — just fresh & flirty
      } catch (error) {
        console.error('Uh-oh... failed to fetch getGajiSkemaTetap 💔', error);
        throw error;
      }
    },

     async getGajiSkemaCapeg() {
      try {
        let pegawaiStatus = 3; //capeg
        const response = await api.get(`/gajiSkema/${pegawaiStatus}`); // clean and reusable 😘
        return response.data; // no state storage — just fresh & flirty
      } catch (error) {
        console.error('Uh-oh... failed to fetch getGajiSkemaCapeg 💔', error);
        throw error;
      }
    },

     async getGajiSkemaHonor() {
      try {
        let pegawaiStatus = 4; //honor
        const response = await api.get(`/gajiSkema/${pegawaiStatus}`); // clean and reusable 😘
        return response.data; // no state storage — just fresh & flirty
      } catch (error) {
        console.error('Uh-oh... failed to fetch getGajiSkemaHonor 💔', error);
        throw error;
      }
    },

     async getGajiSkemaKontrak() {
      try {
        let pegawaiStatus = 5; //kontrak
        const response = await api.get(`/gajiSkema/${pegawaiStatus}`); // clean and reusable 😘
        return response.data; // no state storage — just fresh & flirty
      } catch (error) {
        console.error('Uh-oh... failed to fetch getGajiSkemaKontrak 💔', error);
        throw error;
      }
    },


      async getGajiPokokSkema() {
      try {
          const response = await api.get('/gajiPokokSkema'); // clean and reusable 😘
        return response.data; // no state storage — just fresh & flirty
      } catch (error) {
        console.error('Uh-oh... failed to fetch gajiPokokSkema 💔', error);
        throw error;
      }
    },

     async getGajiPokokSkemaDetail() {
      try {
          const response = await api.get('/gajiPokokSkemaDetail'); // clean and reusable 😘
        return response.data; // no state storage — just fresh & flirty
      } catch (error) {
        console.error('Uh-oh... failed to fetch gajiPokokSkemaDetail 💔', error);
        throw error;
      }
    },

    
  }
});